// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"705140c5","977":"5e12beff"}[chunkId] + ".chunk.js";
};